(function () {
  const State = window.ThlBedBuilderState;
  if (!State) return;
  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
  const checkmark = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m5 12 4.5 4.5L19 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  // Measurements from /pages/size-guide (cm). Cotton in the builder is Stonewashed Cotton there.
  const sizeCharts = {
    quilt: {
      linen: [['Double', '180 × 210'], ['Queen', '210 × 210'], ['King', '245 × 210'], ['Super King', '270 × 240']],
      cotton: [['Double', '180 × 210'], ['Queen', '210 × 210'], ['King', '245 × 210']]
    },
    fitted: {
      linen: [['Double', '137 × 196 × 40'], ['Queen', '152 × 203 × 40'], ['King', '180 × 203 × 40']],
      cotton: [['Single', '91 × 193 × 40'], ['Double', '137 × 196 × 40'], ['Queen', '152 × 203 × 50'], ['King', '180 × 203 × 50']]
    },
    flat: {
      linen: [['Double', '230 × 255'], ['Queen', '255 × 260'], ['King', '280 × 260']],
      cotton: [['Single', '180 × 255'], ['Double', '230 × 255'], ['Queen', '255 × 260'], ['King', '280 × 260']]
    },
    standard: { linen: [['standard', '48 × 74']], cotton: [['standard', '48 × 74']] },
    euro: { linen: [['euro', '65 × 65']], cotton: [['euro', '65 × 65']] }
  };

  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    let config;
    try {
      config = JSON.parse(root.querySelector('[data-thl-bed-builder-config]').textContent);
    } catch (_) {
      return;
    }
    const catalog = State.createCatalog(config.products);
    const text = config.text;
    const promotion = config.promotion || { enabled: false, tiers: [] };
    const $ = (selector) => root.querySelector(selector);
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: config.currency || 'AUD' }).format(cents / 100);
    const cartRoot = window.Shopify?.routes?.root || '/';
    const cartUrl = cartRoot + 'cart';
    let state = State.stateFromShareValue(catalog, new URL(window.location.href).searchParams.get('thl_bed'));
    let urlReady = false;
    let open = State.unfinished(catalog, state)[0] || State.KEYS.find((key) => !state[key].confirmed) || null;
    let adding = false;
    let cartError = '';
    let cartBlocked = false;
    let nzConfirmed = false;
    let lastEnlarge = null;
    let previewRequest = 0;
    let renderedSignature = '';
    let previewCloneSerial = 0;
    const imageCache = new Map();
    const previewMaps = new Map((config.preview.maps || []).filter((map) => map.colour).map((map) => [`${map.material}:${map.colour.trim().toLocaleLowerCase()}`, map]));
    const lookupMap = (material, colour) => previewMaps.get(`${material}:${String(colour).trim().toLocaleLowerCase()}`);
    const swatchFor = (material, colour) => lookupMap(material, colour)?.hex || '#e9e7e3';
    const label = (key, material = state[key]?.material) => key === 'quilt' && material === 'linen' ? text.quilt_set : key === 'standard' && State.includedPillows(catalog, state) ? text.extra_standard : text[key];
    const lines = () => State.selectedLines(catalog, state);
    const pending = () => State.unfinished(catalog, state);
    const tierLabel = (tier, isLast) => String(text.promo_tier || 'Buy {count}{plus} · {percent}% off')
      .replace('{count}', tier.quantity).replace('{plus}', isLast ? '+' : '').replace('{percent}', tier.percent);
    const announce = (message) => { $('[data-announcer]').textContent = message; };
    const chip = (material, colour) => `<span class="thl-bed-builder__chip" style="background-color:${esc(swatchFor(material, colour))}" aria-hidden="true"></span>`;
    const sizeChartTrigger = (key) => `<button type="button" class="thl-bed-builder__size-chart-trigger" data-size-chart="${key}" aria-expanded="false" aria-controls="thl-bed-builder-size-chart-${root.dataset.sectionId}-${key}">${esc(text.size_chart)}</button>`;
    const sizeChartPopover = (key) => `<div class="thl-bed-builder__size-chart" id="thl-bed-builder-size-chart-${root.dataset.sectionId}-${key}" data-size-chart-popover="${key}" role="dialog" aria-label="${esc(`${label(key)} ${text.size_chart}`)}" hidden></div>`;
    function chartMarkup(key) {
      const item = state[key];
      const rows = sizeCharts[key]?.[item.material] || [];
      const selected = key === 'standard' || key === 'euro' ? key : item.size;
      const missingSelectedSize = item.size && key !== 'standard' && key !== 'euro' && !rows.some(([size]) => State.same(size, item.size));
      return `<div class="thl-bed-builder__size-chart-heading"><strong>${esc(`${label(key)} · ${text[item.material]}`)}</strong><button type="button" data-size-chart-close aria-label="${esc(text.close_size_chart)}">×</button></div><table><thead><tr><th scope="col">${esc(text.size)}</th><th scope="col">${esc(text.dimensions_cm)}</th></tr></thead><tbody>${rows.map(([size, dimensions]) => `<tr${State.same(size, selected) ? ' class="thl-bed-builder__size-chart-selected"' : ''}><th scope="row">${esc(text[size] || size)}</th><td>${esc(dimensions)}</td></tr>`).join('')}</tbody></table>${missingSelectedSize ? `<p>${esc(text.size_not_listed)} ${esc(item.size)}</p>` : ''}${key === 'standard' || key === 'euro' ? `<p>${esc(key === 'standard' ? text.pair_pack : text.single_pack)}</p>` : ''}`;
    }
    function closeSizeChart(restoreFocus = false) {
      const popover = $('[data-size-chart-popover]:not([hidden])');
      if (!popover) return;
      const key = popover.dataset.sizeChartPopover;
      popover.hidden = true;
      popover.replaceChildren();
      const trigger = root.querySelector(`[data-size-chart="${key}"]`);
      trigger?.setAttribute('aria-expanded', 'false');
      if (restoreFocus) trigger?.focus({ preventScroll: true });
    }

    function panel(key, index) {
      const item = state[key];
      const status = State.statusFor(catalog, key, item);
      const confirmed = State.isConfirmed(catalog, key, item);
      const saved = item.confirmed;
      const savedVariant = saved ? State.variantFor(catalog, key, saved) : null;
      const chosenProduct = State.productFor(catalog, key, item.material);
      const sizes = State.sizes(catalog, key, item.material);
      const colours = State.colours(catalog, key, item.material);
      const detail = confirmed ? `${esc(text[item.material])} · ${esc(key === 'euro' ? `${item.quantity} × ${text.single_unit}` : item.size)} · <span class="thl-bed-builder__colour-name">${esc(item.colour)}${chip(item.material, item.colour)}</span>` : saved ? esc(text.changes_pending) : status === 'complete' ? esc(text.ready) : status === 'unavailable' ? esc(text.unavailable) : status === 'incomplete' ? esc(text.incomplete) : esc(text.choose_options);
      const materials = State.MATERIALS.map((material) => `<button type="button" class="thl-bed-builder__option" data-item="${key}" data-field="material" data-value="${material}" aria-pressed="${item.material === material}" ${State.productFor(catalog, key, material) ? '' : 'disabled'}>${esc(text[material])}</button>`).join('');
      const sizeButtons = sizes.map((size) => `<button type="button" class="thl-bed-builder__option thl-bed-builder__size" data-item="${key}" data-field="size" data-value="${esc(size)}" aria-pressed="${item.size === size}">${esc(size)}</button>`).join('');
      const swatches = colours.map((colour) => {
        const variant = chosenProduct?.variants.find((entry) => State.same(entry.size, item.size) && State.same(entry.colour, colour));
        const disabled = !item.size || !variant?.available;
        const reason = !item.size ? text.choose_size : !variant ? text.unavailable : !variant.available ? text.unavailable : colour;
        return `<button type="button" class="thl-bed-builder__swatch-button" data-item="${key}" data-field="colour" data-value="${esc(colour)}" aria-pressed="${State.same(item.colour, colour)}" aria-label="${esc(`${colour}${disabled ? ` — ${reason}` : ''}`)}" title="${esc(`${colour} — ${reason}`)}" ${disabled ? 'disabled' : ''}><span class="thl-bed-builder__swatch" style="background-color:${esc(swatchFor(item.material, colour))}"></span></button>`;
      }).join('');
      const pendingChange = item.touched && !confirmed;
      const footer = status === 'empty' ? '' : `<div class="thl-bed-builder__panel-footer">${status === 'complete' && !confirmed ? `<button type="button" class="thl-bed-builder__confirm" data-confirm="${key}">${esc(text.confirm)}</button>` : `<span class="${status === 'unavailable' ? 'thl-bed-builder__warning' : 'thl-bed-builder__muted'}">${esc(confirmed ? text.confirmed : status === 'incomplete' ? text.incomplete : text.unavailable)}</span>`}<span>${pendingChange ? `<button type="button" class="thl-bed-builder__text-button" data-discard="${key}">${esc(text.cancel)}</button>` : ''}${saved ? `<button type="button" class="thl-bed-builder__text-button" data-remove="${key}">${esc(text.remove)}</button>` : ''}</span></div>`;
      return `<article class="thl-bed-builder__panel${open === key ? ' thl-bed-builder__panel--open' : ''}"><h2><button type="button" class="thl-bed-builder__panel-heading" data-open="${key}" id="thl-bed-builder-heading-${root.dataset.sectionId}-${key}" aria-expanded="${open === key}" aria-controls="thl-bed-builder-panel-${root.dataset.sectionId}-${key}"><span class="thl-bed-builder__step${confirmed ? ' thl-bed-builder__step--complete' : ''}" aria-hidden="true">${confirmed ? checkmark : index + 1}</span><span class="thl-bed-builder__panel-copy"><span class="thl-bed-builder__panel-title">${esc(label(key))}</span><span class="thl-bed-builder__detail">${detail}</span></span>${savedVariant ? `<span class="thl-bed-builder__panel-price">${money(savedVariant.price * saved.quantity)}</span>` : ''}</button></h2><div class="thl-bed-builder__panel-content" id="thl-bed-builder-panel-${root.dataset.sectionId}-${key}" role="region" aria-labelledby="thl-bed-builder-heading-${root.dataset.sectionId}-${key}" ${open === key ? '' : 'hidden'}><fieldset><legend>${esc(text.material)}</legend><div class="thl-bed-builder__material-options">${materials}</div></fieldset>${key === 'standard' || key === 'euro' ? `<div class="thl-bed-builder__size-chart-anchor thl-bed-builder__pack-row"><p class="thl-bed-builder__pack-note">${esc(key === 'standard' ? text.pair_pack : text.single_pack)}</p>${sizeChartTrigger(key)}${sizeChartPopover(key)}</div>` : `<fieldset class="thl-bed-builder__size-chart-anchor"><legend><span>${esc(text.size)}</span>${sizeChartTrigger(key)}</legend><div class="thl-bed-builder__size-options">${sizeButtons}</div>${sizeChartPopover(key)}</fieldset>`}<fieldset><legend>${esc(text.colour)}${item.colour ? ` <span>${esc(item.colour)}</span>` : ''}</legend><div class="thl-bed-builder__colour-options">${swatches}</div></fieldset>${key === 'euro' ? `<fieldset><legend>${esc(text.quantity)}</legend><div class="thl-bed-builder__size-options">${[1, 2].map((quantity) => `<button type="button" class="thl-bed-builder__option" data-item="euro" data-field="quantity" data-value="${quantity}" aria-pressed="${item.quantity === quantity}">${quantity}</button>`).join('')}</div></fieldset>` : ''}${key === 'quilt' && item.material === 'linen' ? `<p class="thl-bed-builder__included">${esc(text.included)}</p>` : ''}${key === 'standard' && State.includedPillows(catalog, state) ? `<p class="thl-bed-builder__included">${esc(text.extra_note)}</p>` : ''}${footer}</div></article>`;
    }

    function lineMarkup(line) {
      const title = label(line.key, line.material);
      return `<div class="thl-bed-builder__summary-line"><div><h3>${esc(title)}</h3><p>${esc(text[line.material])} · ${esc(line.key === 'euro' ? `${line.quantity} × ${text.single_unit}` : line.size)} · <span class="thl-bed-builder__colour-name">${esc(line.colour)}${chip(line.material, line.colour)}</span></p>${line.key === 'quilt' && line.material === 'linen' ? `<p>${esc(text.included_summary)}</p>` : ''}<div class="thl-bed-builder__line-actions"><button type="button" data-edit="${line.key}">${esc(text.edit)}</button><button type="button" data-remove="${line.key}">${esc(text.remove)}</button></div></div><strong>${money(line.variant.price * line.quantity)}</strong></div>`;
    }

    function pendingMarkup(key) {
      const item = state[key];
      const pendingLabel = item.confirmed ? text.changes_pending : text.not_added_yet;
      return `<div class="thl-bed-builder__summary-pending"><div class="thl-bed-builder__summary-pending-heading"><strong>${esc(label(key))}</strong><span>${esc(pendingLabel)}</span></div><p>${esc(text.unfinished_message)}</p><div class="thl-bed-builder__line-actions"><button type="button" data-edit="${key}">${esc(text.finish_piece)}</button><button type="button" data-discard="${key}">${esc(text.discard)}</button></div></div>`;
    }

    function needsNzSizing() {
      return config.country === 'NZ' && lines().some((line) => State.same(line.size, 'Super King'));
    }

    function checkout(mobile, estimate) {
      const chosen = lines();
      const unfinished = pending();
      const disabled = adding || cartBlocked || !chosen.length || unfinished.length || (needsNzSizing() && !nzConfirmed);
      const buttonText = adding ? text.adding : mobile ? text.add : text.add_desktop;
      const discounted = promotion.enabled && estimate.valid && estimate.tier;
      return `${mobile && chosen.length ? `<div class="thl-bed-builder__subtotal"><span>${esc(discounted ? text.promo_estimated : config.currency)}</span><strong>${money(discounted ? estimate.estimatedTotal : estimate.original)}</strong></div>` : ''}<div class="thl-bed-builder__buy-actions"><button type="button" class="thl-bed-builder__buy" data-add ${disabled ? 'disabled' : ''}>${esc(buttonText)}</button>${cartBlocked ? `<a href="${esc(cartUrl)}">${esc(text.view_cart)}</a>` : ''}</div>${needsNzSizing() ? `<label class="thl-bed-builder__nz-guard"><input type="checkbox" data-nz-check ${nzConfirmed ? 'checked' : ''}><span>${esc(text.nz_sizing)} ${esc(text.nz_confirm)}</span></label>` : ''}${cartError ? `<p class="thl-bed-builder__cart-error" role="alert">${esc(cartError)}</p>` : ''}<p class="thl-bed-builder__checkout-hint">${esc(unfinished.length ? text.pending_hint : text.checkout_hint)}</p>`;
    }

    function render(restoreFocus = false) {
      const active = restoreFocus && root.contains(document.activeElement) ? { ...document.activeElement.dataset } : null;
      $('[data-panels]').innerHTML = State.KEYS.map(panel).join('');
      const chosen = lines();
      const unfinished = pending();
      const estimate = State.promotionEstimate(catalog, state, promotion);
      const showPromotion = promotion.enabled && estimate.valid;
      const promotionBoxes = root.querySelectorAll('[data-promotion]');
      promotionBoxes.forEach((box) => { box.hidden = !showPromotion; });
      $('[data-promotion-error]').hidden = !promotion.enabled || estimate.valid || !promotion.designMode;
      $('[data-promotion-error]').textContent = text.promo_config_error;
      if (showPromotion) {
        const lastQuantity = promotion.tiers.at(-1).quantity;
        const progress = Math.min(estimate.eligibleQuantity, lastQuantity);
        promotionBoxes.forEach((box) => {
          box.querySelector('[data-promotion-heading]').textContent = promotion.heading || '';
          const track = box.querySelector('[data-promotion-track]');
          track.setAttribute('aria-label', promotion.heading || 'Bundle & Save');
          track.setAttribute('aria-valuemax', String(lastQuantity));
          track.setAttribute('aria-valuenow', String(progress));
          track.setAttribute('aria-valuetext', estimate.tier ? tierLabel(estimate.tier, estimate.tier === promotion.tiers.at(-1)) : `${estimate.eligibleQuantity} ${text.pieces}`);
          box.querySelector('[data-promotion-fill]').style.width = `${progress / lastQuantity * 100}%`;
          const tiers = box.querySelector('[data-promotion-tiers]');
          tiers.style.gridTemplateColumns = `repeat(${promotion.tiers.length}, minmax(0, 1fr))`;
          promotion.tiers.forEach((tier, index) => {
            const item = Array.from(tiers.children).find((child) => child.dataset.discountTierId === tier.id);
            if (!item) return;
            item.textContent = String(text.summary_discount).replace('{percent}', tier.percent);
            item.setAttribute('aria-label', tierLabel(tier, index === promotion.tiers.length - 1));
            item.classList.toggle('thl-bed-builder__promotion-tier--active', estimate.tier?.id === tier.id);
          });
        });
      }
      root.classList.toggle('thl-bed-builder--has-selection', chosen.length > 0);
      const pieceCount = chosen.reduce((count, line) => count + line.quantity, 0);
      $('[data-piece-count]').textContent = `${pieceCount} ${pieceCount === 1 ? text.piece : text.pieces}`;
      $('[data-summary-estimated]').textContent = money(estimate.estimatedTotal);
      $('[data-summary-discount]').textContent = String(text.summary_discount).replace('{percent}', estimate.tier?.percent || 0);
      $('[data-summary-total]').textContent = money(estimate.original);
      $('[data-summary-lines]').innerHTML = chosen.map(lineMarkup).join('');
      $('[data-summary-pending]').innerHTML = unfinished.map(pendingMarkup).join('');
      const showEstimate = showPromotion && Boolean(estimate.tier) && chosen.length > 0;
      $('[data-summary-total-row]').hidden = !chosen.length || showEstimate;
      $('[data-summary-promotion]').hidden = !showEstimate;
      $('[data-summary-promotion]').innerHTML = showEstimate ? `<div><span>${esc(text.promo_original)}</span><strong>${money(estimate.original)}</strong></div><div><span>${esc(text.promo_current)}</span><strong>${esc(tierLabel(estimate.tier, promotion.tiers.at(-1) === estimate.tier))}</strong></div><div><span>${esc(text.promo_savings)}</span><strong>−${money(estimate.savings)}</strong></div><div class="thl-bed-builder__summary-promotion-total"><span>${esc(text.promo_estimated)}</span><strong>${money(estimate.estimatedTotal)}</strong></div>${promotion.note ? `<p>${esc(promotion.note)}</p>` : ''}` : '';
      $('[data-summary-note]').hidden = !chosen.length;
      $('[data-desktop-checkout]').innerHTML = checkout(false, estimate);
      $('[data-mobile-checkout-content]').innerHTML = checkout(true, estimate);
      if (active) {
        const target = active.item ? root.querySelector(`[data-item="${active.item}"][data-field="${active.field}"][data-value="${CSS.escape(active.value)}"]`) : active.open ? root.querySelector(`[data-open="${active.open}"]`) : null;
        target?.focus({ preventScroll: true });
      }
      updatePreview();
      if (urlReady) syncShareUrl();
    }

    function syncShareUrl() {
      const url = new URL(window.location.href);
      const value = State.shareValue(catalog, state);
      if (value) url.searchParams.set('thl_bed', value);
      else url.searchParams.delete('thl_bed');
      const next = `${url.pathname}${url.search}${url.hash}`;
      if (next !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
        window.history.replaceState(window.history.state, '', next);
      }
    }

    function imageFor(source) {
      if (imageCache.has(source)) return imageCache.get(source);
      const pending = new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => Promise.resolve(image.decode ? image.decode() : undefined).then(() => resolve(image), reject);
        image.onerror = () => reject(new Error('Preview asset unavailable'));
        image.src = source;
      });
      imageCache.set(source, pending);
      pending.catch(() => imageCache.delete(source));
      return pending;
    }

    function cloneScene(scene) {
      const copy = scene.cloneNode(true);
      const ids = new Map();
      copy.querySelectorAll('[id]').forEach((node) => {
        const old = node.id;
        node.id = `${old}-copy-${++previewCloneSerial}`;
        ids.set(old, node.id);
      });
      copy.querySelectorAll('*').forEach((node) => {
        node.getAttributeNames().forEach((name) => {
          let value = node.getAttribute(name);
          ids.forEach((next, old) => { value = value.replaceAll(`url(#${old})`, `url(#${next})`); });
          if (value !== node.getAttribute(name)) node.setAttribute(name, value);
        });
      });
      return copy;
    }

    function syncZoomPreview() {
      if ($('[data-preview-dialog]').open) $('[data-zoom-scene]').replaceChildren(cloneScene($('[data-scene]')));
    }

    function showFallback(message, key) {
      const fallback = $('[data-preview-fallback]');
      const previewLines = State.previewLines(catalog, state);
      const selected = previewLines.find((line) => line.key === key) || previewLines[0];
      const image = selected?.variant.image || selected?.product.image;
      if (image) {
        $('[data-fallback-image]').src = image;
        $('[data-fallback-image]').alt = `${selected.product.title} · ${selected.colour}`;
        fallback.hidden = false;
      } else {
        fallback.hidden = true;
      }
      $('[data-fallback-text]').textContent = message;
      $('[data-preview-status]').textContent = message;
    }

    function updatePreview(force = false) {
      const request = ++previewRequest;
      const layers = State.previewLayers(catalog, state);
      if (!config.preview.base) {
        $('[data-scene-layers]').replaceChildren();
        showFallback(text.preview_missing, layers[0]?.key);
        renderedSignature = '';
        syncZoomPreview();
        return;
      }
      const mobile = window.matchMedia('(max-width: 760px)').matches;
      const responsiveUrl = (source) => {
        if (!source || !mobile || !source.includes('cdn.shopify.com')) return source;
        const url = new URL(source, window.location.href);
        if (url.searchParams.has('width')) url.searchParams.set('width', '800');
        return url.toString();
      };
      const sources = layers.map((layer) => {
        const source = responsiveUrl(lookupMap(layer.material, layer.colour)?.layers?.[layer.asset] || null);
        const mask = responsiveUrl(config.preview.masks?.[layer.asset] || null);
        return { ...layer, source, mask };
      });
      const firstMissing = sources.find((layer) => !layer.source || !layer.mask);
      const signature = JSON.stringify(sources.map((layer) => [layer.slot, layer.source, layer.mask]));
      if (firstMissing) {
        showFallback(text.preview_missing, firstMissing.key);
        return;
      }
      if (signature === renderedSignature && !force) {
        $('[data-preview-status]').textContent = '';
        $('[data-preview-fallback]').hidden = true;
        return;
      }
      $('[data-preview-status]').textContent = sources.length ? text.preview_updating : '';
      $('[data-preview-fallback]').hidden = true;
      if (!sources.length) {
        $('[data-scene-layers]').replaceChildren();
        $('[data-scene]').setAttribute('aria-label', text.neutral_alt);
        renderedSignature = signature;
        syncZoomPreview();
        return;
      }
      Promise.all(sources.flatMap((layer) => [imageFor(layer.source), imageFor(layer.mask)])).then((images) => {
        if (request !== previewRequest) return;
        const invalidIndex = images.findIndex((image) => !image.naturalWidth || image.naturalWidth !== image.naturalHeight);
        if (invalidIndex !== -1) {
          showFallback(text.preview_missing, sources[Math.floor(invalidIndex / 2)].key);
          return;
        }
        const fragment = document.createDocumentFragment();
        sources.forEach((layer) => {
          const image = document.createElement('img');
          image.className = 'thl-bed-builder__layer';
          image.dataset.slot = layer.slot;
          image.src = layer.source;
          image.alt = '';
          image.decoding = 'async';
          if (layer.mask) {
            image.classList.add('thl-bed-builder__layer--masked');
            image.style.maskImage = `url(${JSON.stringify(layer.mask)})`;
            image.style.webkitMaskImage = `url(${JSON.stringify(layer.mask)})`;
          }
          fragment.append(image);
        });
        $('[data-scene-layers]').replaceChildren(fragment);
        $('[data-scene]').setAttribute('aria-label', `${text.preview_alt}: ${State.previewLines(catalog, state).map((line) => `${text[line.key]}, ${text[line.material]}, ${line.colour}`).join('; ')}`);
        renderedSignature = signature;
        $('[data-preview-status]').textContent = '';
        syncZoomPreview();
      }).catch(() => {
        if (request === previewRequest) showFallback(text.preview_failed, sources[0]?.key);
      });
    }

    function readCart() {
      return fetch(cartRoot + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then((response) => {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      });
    }

    async function addSelection() {
      if (adding || cartBlocked || !lines().length || pending().length || (needsNzSizing() && !nzConfirmed)) return;
      const items = State.cartItems(catalog, state);
      adding = true;
      cartError = '';
      render();
      let before;
      try {
        before = await readCart();
      } catch (_) {
        adding = false;
        cartError = text.cart_unknown;
        render();
        return;
      }
      let requestError = null;
      try {
        const response = await fetch(cartRoot + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error('Cart add failed');
      } catch (error) {
        requestError = error;
      }
      let after;
      try {
        after = await readCart();
      } catch (_) {
        adding = false;
        cartBlocked = true;
        cartError = text.cart_unknown;
        render();
        return;
      }
      const added = State.cartDeltaStatus(before, after, items);
      adding = false;
      if (added === 'complete') {
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true }));
        window.location.assign(cartUrl);
        return;
      }
      if (added === 'partial') {
        cartBlocked = true;
        cartError = text.cart_partial;
      } else if (added === 'none' && requestError) {
        cartError = text.cart_error;
      } else {
        cartBlocked = true;
        cartError = text.cart_unknown;
      }
      render();
    }

    function syncPreviewOffset() {
      const headerHeight = document.querySelector('.header__outer-wrapper')?.getBoundingClientRect().height || 0;
      root.style.setProperty('--bb-sticky-top', `${Math.max(24, Math.ceil(headerHeight) + 16)}px`);
      root.style.setProperty('--bb-mobile-sticky-top', `${Math.ceil(headerHeight)}px`);
    }

    function keepPreviewVisibleAfterConfirm() {
      if (window.matchMedia('(max-width: 760px)').matches) return;
      window.requestAnimationFrame(() => {
        const scene = $('[data-scene]')?.getBoundingClientRect();
        if (!scene?.height) return;
        const top = parseFloat(getComputedStyle(root).getPropertyValue('--bb-sticky-top')) || 24;
        if (scene.top < top - 1) window.scrollBy({ top: scene.top - top, behavior: 'instant' });
      });
    }

    root.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (button.dataset.sizeChart) {
        const key = button.dataset.sizeChart;
        const popover = root.querySelector(`[data-size-chart-popover="${key}"]`);
        const wasOpen = !popover.hidden;
        closeSizeChart();
        if (!wasOpen) {
          popover.innerHTML = chartMarkup(key);
          popover.hidden = false;
          button.setAttribute('aria-expanded', 'true');
          popover.querySelector('[data-size-chart-close]')?.focus({ preventScroll: true });
        }
        return;
      }
      if (button.hasAttribute('data-size-chart-close')) {
        closeSizeChart(true);
        return;
      }
      if (button.dataset.open) {
        open = open === button.dataset.open ? null : button.dataset.open;
        render(true);
        return;
      }
      if (button.dataset.field) {
        const { item, field, value } = button.dataset;
        state = State.change(catalog, state, item, field, field === 'quantity' ? Number(value) : value);
        nzConfirmed = false;
        cartError = '';
        render(true);
        return;
      }
      if (button.dataset.confirm) {
        const key = button.dataset.confirm;
        state = State.confirmItem(catalog, state, key);
        if (!State.isConfirmed(catalog, key, state[key])) return;
        open = null;
        nzConfirmed = false;
        render();
        root.querySelector(`[data-open="${key}"]`)?.focus({ preventScroll: true });
        keepPreviewVisibleAfterConfirm();
        announce(`${label(key)} ${text.confirmed}. ${money(State.subtotal(catalog, state))}`);
        return;
      }
      if (button.dataset.discard) {
        const key = button.dataset.discard;
        state = State.discardChanges(catalog, state, key);
        open = null;
        render();
        root.querySelector(`[data-open="${key}"]`)?.focus({ preventScroll: true });
        return;
      }
      if (button.dataset.remove) {
        const key = button.dataset.remove;
        state = State.remove(catalog, state, key);
        nzConfirmed = false;
        render();
        root.querySelector(`[data-open="${key}"]`)?.focus({ preventScroll: true });
        return;
      }
      if (button.dataset.edit) {
        open = button.dataset.edit;
        render();
        const heading = root.querySelector(`[data-open="${open}"]`);
        heading?.focus({ preventScroll: true });
        heading?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (button.hasAttribute('data-add')) {
        addSelection();
        return;
      }
      if (button.hasAttribute('data-enlarge')) {
        lastEnlarge = button;
        $('[data-zoom-scene]').replaceChildren(cloneScene($('[data-scene]')));
        $('[data-preview-dialog]').showModal();
        return;
      }
      if (button.hasAttribute('data-dialog-close')) {
        $('[data-preview-dialog]').close();
        return;
      }
      if (button.hasAttribute('data-preview-retry')) {
        updatePreview(true);
        return;
      }
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target) || !event.target.closest('.thl-bed-builder__size-chart-anchor')) closeSizeChart();
    });
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && $('[data-size-chart-popover]:not([hidden])')) {
        event.preventDefault();
        closeSizeChart(true);
      }
    });

    root.addEventListener('change', (event) => {
      if (!event.target.matches('[data-nz-check]')) return;
      nzConfirmed = event.target.checked;
      root.querySelectorAll('[data-nz-check]').forEach((checkbox) => { checkbox.checked = nzConfirmed; });
      root.querySelectorAll('[data-add]').forEach((button) => { button.disabled = !nzConfirmed || adding || cartBlocked || !lines().length || pending().length; });
    });
    $('[data-summary]').addEventListener('toggle', (event) => {
      $('[data-summary-toggle-label]').textContent = event.target.open ? text.hide_summary : text.view_summary;
    });
    $('[data-preview-dialog]').addEventListener('close', () => lastEnlarge?.focus({ preventScroll: true }));
    window.addEventListener('resize', syncPreviewOffset, { passive: true });
    window.addEventListener('popstate', () => {
      urlReady = false;
      state = State.stateFromShareValue(catalog, new URL(window.location.href).searchParams.get('thl_bed'));
      nzConfirmed = false;
      render();
      urlReady = true;
    });
    syncPreviewOffset();
    render();
    urlReady = true;
    syncShareUrl();
  }

  function initAll() {
    document.querySelectorAll('[data-thl-bed-builder]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
